import { useScenariosStore } from '@/stores/scenarios';
import { useWorkpackagesStore } from '@/stores/workpackages';

// The scenario a route names and its workpackage, or nulls while either is still loading.
// Call inside an active pinia context.
export function getWorkpackageScenarioFromRoute(route) {
  const id = route?.params?.scenarioId;
  if (!id) return { scenario: null, workpackage: null };

  const scenariosStore = useScenariosStore();
  // The loaded list is empty on a cold deep link, where loadState sets selectedScenario first.
  const scenario =
    scenariosStore.getScenarioById(id) ||
    (scenariosStore.selectedScenario?._id === id ? scenariosStore.selectedScenario : null);
  if (!scenario?.name) return { scenario: null, workpackage: null };

  const workpackagesStore = useWorkpackagesStore();
  // Keyed off the scenario's own workpackageId: selection and route settle separately on a switch.
  const workpackage =
    workpackagesStore.getWorkpackageById(scenario.workpackageId) ||
    (workpackagesStore.selectedWorkpackage?._id === scenario.workpackageId
      ? workpackagesStore.selectedWorkpackage
      : null);

  return { scenario, workpackage };
}
